import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SharedService } from 'app/modules/common/services/shared-service';
import { SelectionGenericService } from 'app/modules/selection-generic/services/selection-generic.service';
import { IDropDown } from '../../models/IDropDown';
import { RegistroService } from '../../../services/registro.service';
import moment from 'moment';
@Component({
    selector: 'app-revision-popup',
    templateUrl: './revision-popup.component.html',
    styleUrls: ['./revision-popup.component.scss'],
    standalone: false
})
export class RevisionPopupComponent implements OnInit {

  public revisionForm: UntypedFormGroup
  public coordinatorList: IDropDown<string>[]

  constructor(
    public _dialogRef: MatDialogRef<RevisionPopupComponent>,
    public _fb: UntypedFormBuilder,
    private _sharedService: SharedService,
    public _selectionService: SelectionGenericService,
    private _registroService: RegistroService,

    @Inject(MAT_DIALOG_DATA)
    private _dialogData: any
  ) {
    this.GetCoordinatorsList()
    //creates the form with default values
    this.CreateAgendaForm(_dialogData.companyId);
    
    if (_dialogData.data !== null) {
      this.revisionForm.patchValue({
        Id: _dialogData.data.id,
        Fecha: _dialogData.data.fecha,
        Coordinador: _dialogData.data.autor,
        Comentarios: _dialogData.data.texto,
      });
    }
  }

  ngOnInit(): void {
  }

  private CreateAgendaForm(companyId: number): void {
    this.revisionForm = this._fb.group({
      Id: [0],
      EmpresaId: [companyId],
      Fecha: [moment(), Validators.required],
      Coordinador: [null],
      Comentarios: [null]
    })
  }

  private ConvertDateToStringSpanishFormat():UntypedFormGroup {      
    //This to avoid date reduce by 12 hours and when recieveing at the API  
    let getDate = this.revisionForm.get('Fecha').value
    let formatedStringDate = moment(getDate).format('MM/DD/YYYY')
    //remove refference and create a new form object
    let formObject = {...this.revisionForm.value} 
    formObject.Fecha = formatedStringDate
    return formObject
  }


  public onSubmit() {
    this.revisionForm.markAllAsTouched();
    this.revisionForm.updateValueAndValidity();

    if (this.revisionForm.valid) {
      //This to avoid date reduce by 12 hours and when recieveing in API       
      let updatedForm = this.ConvertDateToStringSpanishFormat()
      //add data  
      if (this.revisionForm.value.Id === 0) {
        this.AddRevision(updatedForm)
      } else {
        this.UpdateRevision(updatedForm)
      }
    }
  }


  cancel(submitSuccess: boolean) {
    this._dialogRef.close(submitSuccess == null ? false : submitSuccess);
  }

  private AddRevision(updatedForm) {
    this._registroService.AddRevisionEmpresa(updatedForm)
      .subscribe(res => {
        if (res.code === 0) {
          this._sharedService.ShowSnackBar('Guardado con éxito', 'Okay', 2000);
          this.cancel(true)
        } else {
          this._sharedService.ShowSnackBar('Error al crear', 'Okay', 2000);
        }
      }, err => {
        this._sharedService.ShowSnackBar('Se produjo un error', 'Okay', 2000);
      });
  }

  private UpdateRevision(updatedForm) {
    this._registroService.UpdateRevisionEmpresa(updatedForm)
      .subscribe(res => {
        if (res.code === 0) {
          this._sharedService.ShowSnackBar('Actualizado con éxito', 'Okay', 2000);
          this.cancel(true)
        } else {
          this._sharedService.ShowSnackBar('Error al guardar', 'Okay', 2000);
        }
      }, err => {
        this._sharedService.ShowSnackBar('Se produjo un error', 'Okay', 2000);
      });
  }

  public GetCoordinatorsList() {
    this._selectionService.GetCoordinatorList()
      .subscribe(res => {
        this.coordinatorList = res.result;
      })
  }
}
